import { render, staticRenderFns } from "./Referred.vue?vue&type=template&id=e9acb7f4&scoped=true"
import script from "./Referred.vue?vue&type=script&lang=js"
export * from "./Referred.vue?vue&type=script&lang=js"
import style0 from "./Referred.vue?vue&type=style&index=0&id=e9acb7f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9acb7f4",
  null
  
)

export default component.exports